import React from 'react';
export function EmotionalClose() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-65">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-66">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-100 relative mb-12" data-id="element-67">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-6xl text-gold/30 font-heading" data-id="element-68">
            "
          </div>
          <p className="text-2xl md:text-3xl font-heading text-navy italic relative z-10" data-id="element-69">
            El padre que tiene un sistema puede acompañar a su hijo con calma.
            El padre sin sistema acompaña con miedo. La diferencia entre los dos
            no es el amor — es la herramienta.
          </p>
        </div>
      </div>
    </section>;
}